<template>
  <CockpitDialog
    :title="showMessage ? '报警详情' : '实时监控'"
    @close="closeAlarmList"
    :top="'200px'"
    :left="'400px'"
    :width="'1000px'"
    :height="showMessage ? '440px' : '700px'"
  >
    <div class="w-full h-full flex justify-start items-center" v-if="showMessage">
      <div class="w-60/100 h-full flex justify-start items-center flex-col mr-20px">
        <!-- <el-button class="w-full !h-90/100 text-30px">这是一个图片</el-button> -->
        <!-- <FLVPlayer :flvPlayUrl="currentRelationData.streamAddress"></FLVPlayer> -->
        <el-carousel
          :interval="2000"
          class="h-full w-full pt-10px"
          trigger="click"
          indicator-position="none"
          arrow="always"
        >
          <el-carousel-item v-for="item in currentRelationData.aiIllegalResults" :key="item.id">
            <el-image class="w-full h-full" :src="item.fileUrl" fit="fill"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="w-32/100 h-full flex justify-start items-center flex-col ml-20px">
        <div class="w-full flex justify-start items-center leading-30px h-30px">
          <img src="../../assets/images/titleIcon.png" alt />
          <div class="text-16px text-white ml-4px">报警信息</div>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">所在地：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.orgIdPath
          }}</span>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">设备名称：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.deviceAlias
          }}</span>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">事件项：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.algorithmName
          }}</span>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">发生时间：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.time
          }}</span>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px !leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">事件等级：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.startAlertDegreeName +
              '->' +
              currentRelationData.currentAlertDegreeName
          }}</span>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">是否误报：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.isMisinformation ? '是' : '否'
          }}</span>
          <!-- <el-radio
            class="w-80px text-left h-30px !leading-30px !text-hex-DCDEDE"
            v-model="currentRelationData.isMisinformation"
            :label="true"
            disabled
            >是</el-radio
          >
          <el-radio
            class="w-80px text-left h-30px !leading-30px !text-hex-DCDEDE"
            v-model="currentRelationData.isMisinformation"
            :label="false"
            disabled
            >否</el-radio
          > -->
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">事件状态：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.status === 'PENDING' ? '待处理' : '已处理'
          }}</span>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">处理人：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.handler
          }}</span>
        </div>
        <div class="w-full flex text-hex-DCDEDE h-30px leading-30px">
          <span class="w-90px truncate text-left text-14px !leading-30px">处理时间：</span>
          <span class="truncate text-white font-bold text-14px !leading-30px">{{
            currentRelationData.handleTime
          }}</span>
        </div>
      </div>
    </div>
    <div class="w-full h-full flex justify-start items-center" v-else>
      <div class="w-full h-full flex justify-start items-center flex-col ml-20px mr-20px">
        <!-- <el-button class="w-full !h-90/100 text-30px">这是一个图片</el-button> -->
        <FLVPlayer :flvPlayUrl="currentRelationData.streamAddress"></FLVPlayer>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import { isNil, get, find, isEmpty, omit, head, map } from 'lodash'

const CockpitDialog = () => {
  return import('@/components/cockpit/CockpitDialog')
}
const FLVPlayer = () => {
  return import('../player/FLVPlayer')
}
export default {
  components: {
    CockpitDialog,
    FLVPlayer,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    showMessage: {
      type: Boolean,
      defalut: false,
    },
    monitorData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      currentRelationData: {},
    }
  },
  async created() {
    // console.log('传递过来的数据为：', this.monitorData)
    this.currentRelationData = { ...this.monitorData }
  },
  methods: {
    closeAlarmList() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/table.scss';

::v-deep .el-loading-mask {
  background: linear-gradient(180deg, rgb(8 34 57 / 90%) 0%, rgba(3, 25, 43, 0.9) 93.96%);
}
::v-deep .el-carousel .el-carousel__container .el-carousel__arrow {
  background-color: #1da7b9;
}
</style>
